module.exports = __webpack_public_path__ + "staticcomp/img/cover.7d736f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/6/cover.jpg
// module id = rP11
// module chunks = 39